import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-orange-500 to-orange-600 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Info */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/0545d2048ed36ebe53df2dae0c0b43d7/cd07971963afdd53018db5f4e5a97aca.png" 
                alt="Picobello Hausservice" 
                className="h-12 w-12 object-contain"
              />
              <span className="text-xl font-bold">Picobello</span>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              Ihr zuverlässiger Partner für Haushaltsauflösung, Entrümpelung und Umzüge in Hildesheim und Umgebung.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Schnellzugriff</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/leistungen" className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  Leistungen
                </Link>
              </li>
              <li>
                <button onClick={() => scrollToSection('buchung')} className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  Buchung
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('bewertungen')} className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  Bewertungen
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Unsere Leistungen</h3>
            <ul className="space-y-2 text-sm text-white/90">
              <li>Haushaltsauflösung</li>
              <li>Entrümpelung</li>
              <li>Möbeltaxi</li>
              <li>Kleine Umzüge</li>
              <li>Ankauf Wertgegenstände</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-smartphone-line text-lg mt-0.5"></i>
                <a href="tel:015758089488" className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  015758089488 (Mobil)
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-lg mt-0.5"></i>
                <a href="tel:051211772025" className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  05121 1772025 (Festnetz)
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-lg mt-0.5"></i>
                <a href="mailto:info@picobellohausservice-hi.de" className="text-white/90 hover:text-white transition-colors text-sm cursor-pointer">
                  info@picobellohausservice-hi.de
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-lg mt-0.5"></i>
                <span className="text-white/90 text-sm">Hildesheim, Deutschland</span>
              </li>
              <li className="flex items-center gap-3 mt-4">
                <a href="https://wa.me/4915758089488" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/80 text-sm">
            © 2025 Picobello Hausservice. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
